import { auth } from '@martyrs/src/modules/auth/views/store/auth.js';

function resetUser(to, from, next) {
  next();
  auth.state.user.phone = '';
  auth.state.user.email = '';
  auth.state.user.avatar = '';
  auth.state.user.password = '';
  auth.state.user.passwordRepeat = '';
}

async function initUser(to, from, next) {
  await auth.actions.initialize();
  next();
}

// Check state before open
function checkUser(to, from, next) {
  if (auth.state.user.phone === '' && auth.state.user.email === '') {
    next('/auth/signin');
  } else {
    next();
  }
}

async function requiresNoAuth(to, from, next) {
  // На сервере вход известен только из куки, без проверки токена (SSR в сеть
  // не ходит). Отозванная кука уводила отсюда на профиль, сервер отдавал 404,
  // а браузер после проверки рисовал форму внутри разметки 404. Решение — за
  // браузером: он ждёт проверку куки и только потом уводит вошедшего.
  if (typeof window === 'undefined') return next();

  await auth.actions.revalidated();

  const isLogin = auth.state.access.status;

  console.log(isLogin);
  console.log(auth.state.access);

  console.log('');

  if (isLogin) {
    console.log('havee login');
    return next('/profile/' + auth.state.user._id);
  }

  console.log('not have login');

  next();
}

function requiresAuth(to, from, next) {
  const isLogin = auth.state.access.status;

  if (isLogin !== true) {
    return next({ path: '/auth/signin', query: { returnUrl: to.fullPath } });
  }

  next();
}

async function requiresAdmin(to, from, next) {
  const isLoggedIn = auth.state.access.status;
  const isAdmin = auth.state.access.roles?.includes('ROLE_ADMIN') ? auth.state.access.roles.includes('ROLE_ADMIN') : false;

  if (!isLoggedIn) {
    return next({ path: '/auth/signin', query: { returnUrl: to.fullPath } });
  }

  if (!isAdmin) {
    return next('/401');
  }

  next();
}

export { checkUser, initUser, requiresAdmin, requiresAuth, requiresNoAuth, resetUser };
